import React from 'react';
import Select from 'react-select';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/*import DatePicker from 'react-datepicker';*/
/*import moment from 'moment';
import { toast } from 'react-toastify';*/
import 'react-toastify/dist/ReactToastify.min.css';

import FormHelper from '../../form.js';
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import windowStop from '../../../../../utils/windowStop.js';


export default class ModalAssetLocation extends React.Component {
	constructor(){
		super();
		this.state = {
			MASTER_SITE      : null,
			MASTER_LOCATION  : null,
			LOCATION_FILTERED: null,
			site             : {label:"", value:""},
			location         : {label:"", value:""},
		};
	}

	generateLabel(list, mapping){
	// console.log(list.length)
		try {
			return list.map((val, key) => {
				if(mapping.label === 'Username'){
					val.label 	= val.FirstName +' '+ val.LastName
				}else{
					val.label 	= val[mapping.label];
				}
				val.value 		= val[mapping.value]; 
				return val
			}) 
		} catch (error) {       
			if(list !== null){
				let val 	= []
				val.value 	= list[mapping.value]
				val.label 	= list[mapping.label]
				return val  
			}
			return null
		}
	}

	onCancel(){
		this.props.onCancel();
		this.props.closeModal()
	}

	onSave(){
		if(!FormHelper.validateSite(this.state)) {
			return
		}
		this.props.onSave({
			site : this.state.site.value,
			location : this.state.location.value
		})
		this.props.closeModal();
	}

	readMaster(){
		Presenter.ReadAsMaster(
			RequestProperties.ReadAsMaster(
				'SITE', this, 
				this.readMasterSuccess.bind(this), 
				this.readMasterFailed.bind(this)
			)
		)
		Presenter.ReadAsMaster(
			RequestProperties.ReadAsMaster(
				'LOCATION', this, 
				this.readMasterSuccess.bind(this), 
				this.readMasterFailed.bind(this)
			)
		)
	}

	readMasterSuccess(params, response){
		switch(params.action) {
		    case "SITE":
		        params.self.setState({ MASTER_SITE: this.generateLabel(response.data, {value:'Alias', label:'Name'}) })
		        break;
		    case "LOCATION":
		        params.self.setState({ MASTER_LOCATION: this.generateLabel(response.data, {value:'Alias', label:'Name'}) })
		        break;
		    default:
		        break;
		}
	}

	readMasterFailed(params, response){

	}

	handleSiteChange(event) {
		const obj = {
			// clicked: true,
			site: event,
			location: {label:"", value:""},
			LOCATION_FILTERED: this.getLocationBySite(event.value),
		}
		this.setState(obj);
	}

	handleLocationChange(event) {
		this.setState({
			location: event,
			// clicked: true,
		})
	}

	getLocationBySite(site){
		return this.state.MASTER_LOCATION.filter((val, key) => {
			return val.Site === site
		})
	}

	willMount(){

	}

	willUnMount(){
		this.setState({
			LOCATION_FILTERED : null,
			site : {label:'', value:''},
			location : {label:'', value:''},
		})
	}

	componentDidMount(){
		this.readMaster()
	}

	componentWillUnmount() {
	  windowStop()
	}

	render(){
		return(
			<Modal 
				isOpen={this.props.isOpen} 
				onEnter={() => this.willMount()} 
				onExit={()=>this.willUnMount()} 
				toggle={() => this.onCancel()}
			>
			  <ModalHeader toggle={() => this.onCancel()}>Asset Site And Location</ModalHeader>
			  <ModalBody>
			    <div className="row">
			      <div className="col-sm-12">
			        <div className="row">
			          <div className="form-group col-sm-6">
			            <label htmlFor="site">Site</label>
			            <Select
			              name="site"
			              id="site"
			              placeholder="Type Site"
			              value={this.state.site.value}
			              options={this.state.MASTER_SITE}
			              clearable={false}
			              onChange={(val) => this.handleSiteChange(val)}
			            />

			          </div>
			          <div className="form-group col-sm-6">
			            <label htmlFor="to">Location</label>
			            <Select
			              name="location"
			              id="location"
			              placeholder="Type Location" 
			              value={this.state.location.value}
			              options={this.state.LOCATION_FILTERED}
			              clearable={false}
			              onChange={(val) => this.handleLocationChange(val)}
			            />
			          </div>
			        </div>
			      </div>
			    </div>
			  </ModalBody>
			  <ModalFooter>
			    <Button color="secondary" onClick={() => this.onCancel()}>Cancel</Button>
			    <Button color="primary" onClick={() => this.onSave()}>Save</Button>
			  </ModalFooter>
			</Modal>
		)
	}
}


// WEBPACK FOOTER //
// ./src/App/master/import/helper/component/Modal/ModalAssetLocation.js